import ParentView from "./framework/ParentView";
import State from "./../State";
import CanvasView from "./canvas/CanvasView";
import { PageIds } from "./PageIds";
import GameStateControl from "../GameStateControl.js";
import Page from "./framework/Page";
import GameViewOverlay from "./GameViewOverlay";
import SkillTreeView from "./skillTree/SkillTreeView";
import UserInput from "../input/UserInput";
import PopupViewController from "./menu/PopupViewController";

export default class GameView extends ParentView {
    /**
     * @param {GameStateControl} gameStateControl 
     * @param {UserInput} mineCanvasUserInput
     * @param {UserInput} skillTreeUserInput
     */
    constructor(gameStateControl, mineCanvasUserInput, skillTreeUserInput) {
        super(null, PageIds.GAME_VIEW_CONTAINER);

        /**
         * @private
         * @type {CanvasView}
         */
        this.canvasView = null;
        /**
         * @private
         * @type {SkillTreeView}
         */
        this.skillTreeView = null;

        /**
         * @constant
         * @type {UserInput}
         */
        this.mineCanvasUserInput = mineCanvasUserInput;
        /**
         * @constant
         * @type {UserInput}
         */
        this.skillTreeUserInput = skillTreeUserInput;

        /**
         * @constant
         * @type {GameStateControl}
         */
        this.gameStateControl = gameStateControl;

    }

    /**
     * Called by GameLoop during initialization to create the UI.
     * @param {State} state
     */
    createChildren(state) {

        const elementId = this.getElementId();

        // Clear out any existing child view references.
        //this.clearChildViews();
        this.removeChildViewElements();

        // Clear out the DOM. The above method does this, but here we are just being sure.
        Page.clearChildren(elementId);
            
        this.canvasView = new CanvasView(elementId, state, this.mineCanvasUserInput);
        this.addView(this.canvasView);

        this.skillTreeView = new SkillTreeView(elementId, state.skillTreeGraph, this.skillTreeUserInput);
        this.addView(this.skillTreeView);

        const popupViewController = new PopupViewController();
        popupViewController.addPopupView(this.skillTreeView);

        this.addView(new GameViewOverlay(elementId, state, this.gameStateControl, popupViewController));

        // // Add the toggle container last so that it's on top
        // this.addView(new GameSkillToggleContainer(elementId, this.gameSkillViewController));

        // Initialize the views.
        this.initializeView();
    }

    /**
     * @returns {HTMLCanvasElement}
     */
    getCanvas() {
        return this.canvasView.getCanvas();
    }

    resetGameView() {
        this.removeAll();
    }
}